export enum HttpExceptionCode {
  ACCOUNT_OWNERSHIP_UNVERIFIED = 'ACCOUNT_OWNERSHIP_UNVERIFIED',
  ACTIVATION_KEY_INVALID = 'ACTIVATION_KEY_INVALID',
  ACTIVATION_KEY_MISSING = 'ACTIVATION_KEY_MISSING',
  APPLICATION_NOT_FOUND = 'APPLICATION_NOT_FOUND',
  AUTH_TYPE_INVALID = 'AUTH_TYPE_INVALID',
  BOTH_MISSING = 'BOTH_MISSING',
  BOTH_NOT_FOUND = 'BOTH_NOT_FOUND',
  BOTH_REGISTERED = 'BOTH_REGISTERED',
  DUPLICATE_VEHICLE = 'DUPLICATE_VEHICLE',
  EMAIL_ADDRESS_NOT_FOUND = 'EMAIL_ADDRESS_NOT_FOUND',
  EMAIL_ADDRESS_REGISTERED = 'EMAIL_ADDRESS_REGISTERED',
  LEAD_CHANNEL_NOT_FOUND = 'LEAD_CHANNEL_NOT_FOUND',
  PHONE_NUMBER_MISSING = 'PHONE_NUMBER_MISSING',
  PHONE_NUMBER_NOT_FOUND = 'PHONE_NUMBER_NOT_FOUND',
  PHONE_NUMBER_REGISTERED = 'PHONE_NUMBER_REGISTERED',
  PIN_INVALID = 'PIN_INVALID',
  RE_F_AND_I_VEHICLE_NOT_FOUND = 'RE_F_AND_I_VEHICLE_NOT_FOUND',
  TOO_MANY_REQUESTS = 'TOO_MANY_REQUESTS',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  USER_NOT_FOUND_BY_ID = 'USER_NOT_FOUND_BY_ID',
  VEHICLE_LOAN_ID_MISMATCH = 'VEHICLE_LOAN_ID_MISMATCH',
  VEHICLE_NOT_FOUND_BY_ID = 'VEHICLE_NOT_FOUND_BY_ID',
}
